// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const progressbar = "RadialProgressbar__progressbar__9JsRL";
export const scale = "RadialProgressbar__scale__FoxMe";
export const filling = "RadialProgressbar__filling__aBE2t";
export const green = "RadialProgressbar__green__Ck-nl";
export const blue = "RadialProgressbar__blue__ueJ60";